import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Users, Star, Clock } from 'lucide-react';

function KPICard({ label, value, sub, Icon, iconBg }) {
  return (
    <Card className="border border-slate-200 rounded-xl shadow-sm" data-testid={`kpi-${label}`}>
      <CardContent className="pt-5 pb-5 flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</p>
          <p className="text-3xl font-bold mt-1">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </div>
        <div className={`p-2.5 rounded-lg ${iconBg}`}>
          <Icon className="h-5 w-5 text-white" />
        </div>
      </CardContent>
    </Card>
  );
}

export default function ProtoKPICards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <KPICard label="Total Submissions" value="8" sub="5 unique employees" Icon={FileText} iconBg="bg-slate-800" />
      <KPICard label="Unique Employees" value="5" sub="Across 3 departments" Icon={Users} iconBg="bg-blue-600" />
      <KPICard label="Avg. Overall Rating" value="4.2" sub="Out of 5" Icon={Star} iconBg="bg-emerald-600" />
      <KPICard label="Latest Submission" value="2h ago" sub="Mar 24, 2026" Icon={Clock} iconBg="bg-amber-500" />
    </div>
  );
}
